export default [
  {
    name: 'htQuery',
    path: '/ht/htQuery',
    component: resolve => require(['Views/Ht/htQuery/index.vue'], resolve),
    meta: {
      include: ['HtQuery'],
      index: 1,
      title: '酒店查询',
    }
  },
  {
    name: 'htList',
    path: '/ht/htQuery/htList',
    component: resolve => require(['Views/Ht/htQuery/htList/index.vue'], resolve),
    meta: {
      include: ['HtList', 'HtQuery', 'HtSearch', 'TripAdd', 'TripRoute'],
      index: 2,
      title: '酒店列表',
    }
  },
  {
    name: 'htSearch',
    path: '/ht/htQuery/htSearch',
    component: resolve => require(['Views/Ht/htQuery/htSearch/index.vue'], resolve),
    meta: {
      include: ['HtSearch', 'HtQuery', 'HtList'],
      index: 11,
      title: '酒店筛选',
    }
  },
  {
    name: 'htSignList',
    path: '/ht/htQuery/htSignList',
    component: resolve => require(['Views/Ht/htQuery/htSignList/index.vue'], resolve),
    meta: {
      index: 2,
      title: '协议酒店列表',
      include: [],
    }
  },
  {
    name: 'htMap',
    path: '/ht/htQuery/htMap',
    component: resolve => require(['Views/Ht/htQuery/htMap/index.vue'], resolve),
    meta: {
      index: 21,
      title: '酒店地图',
      include: [],
    }
  },
  {
    name: 'htDetails',
    path: '/ht/htQuery/htDetails',
    component: resolve => require(['Views/Ht/htQuery/htDetails/index.vue'], resolve),
    meta: {
      include: ['HtDetails', 'HtQuery', 'HtList', 'HtMore', 'HtInquiry', 'TripAdd', 'TripRoute'],
      index: 3,
      title: '酒店详情',
    }
  },
  {
    name: 'htDetailsInt',
    path: '/ht/htQuery/htDetailsInt',
    component: resolve => require(['Views/Ht/htQuery/htDetailsInt/index.vue'], resolve),
    meta: {
      index: 3,
      title: '酒店详情',
      include: ['HtDetails', 'HtQuery', 'HtList', 'HtMore', 'HtInquiry'],
    }
  },
  {
    name: 'htMore',
    path: '/ht/htQuery/htMore',
    component: resolve => require(['Views/Ht/htQuery/htMore/index.vue'], resolve),
    meta: {
      include: ['HtMore', 'HtQuery', 'HtList', 'HtDetails'],
      index: 31
    }
  },
  {
    name: 'htInquiry',
    path: '/ht/htQuery/htInquiry',
    component: resolve => require(['Views/Ht/htQuery/htInquiry/index.vue'], resolve),
    meta: {
      include: ['HtInquiry', 'HtQuery', 'HtList', 'HtDetails'],
      index: 32
    }
  },
  {
    name: 'htRemark',
    path: '/ht/htQuery/htRemark',
    component: resolve => require(['Views/Ht/htQuery/htRemark/index.vue'], resolve),
    props: true,
    meta: {
      index: 33,
      title: '添加备注',
      include: ['HtInquiry'],
    }
  },
  {
    name: 'htInquiryDetail',
    path: '/ht/htQuery/htInquiryDetail/:id',
    component: resolve => require(['Views/Ht/htQuery/htInquiryDetail/index.vue'], resolve),
    props: true,
    meta: {
      index: 34,
      title: '询价单详情',
      include: [],
    }
  },
  {
    name: 'htOrder',
    path: '/ht/htOrder',
    component: resolve => require(['Views/Ht/htOrder/index.vue'], resolve),
    meta: {
      title: '酒店订单',
      // 不将htDetails列到include中是因为下单页面更换了出行人后返回上一页涉及违背不违背问题，涉及到数据的同步更新问题 
      include: ['HtInquiry', 'HtQuery', 'HtList'],
      index: 4
    }
  },
  {
    name: 'htOrderInt',
    path: '/ht/htOrderInt',
    component: resolve => require(['Views/Ht/htOrderInt/index.vue'], resolve),
    meta: {
      index: 4,
      title: '国际酒店订单',
      include: [],
    }
  },
  {
    name: 'htOrderDetail',
    path: '/ht/htOrder/htOrderDetail/:id/:isShowGuarantee?',
    component: resolve => require(['Views/Ht/htOrder/htOrderDetail/index.vue'], resolve),
    props: true,
    meta: {
      index: 41,
      title: '酒店订单详情',
      include: [],
    }
  },
  {
    name: 'htRefundDetail',
    path: '/ht/htOrder/htRefundDetail/:id',
    component: resolve => require(['Views/Ht/htOrder/htRefundDetail/index.vue'], resolve),
    props: true,
    meta: {
      index: 42,
      title: '酒店退订详情',
      include: [],
    }
  },
  {
    name: 'htRefund',
    path: '/ht/htOrder/htRefund/:id',
    component: resolve => require(['Views/Ht/htOrder/htRefund/index.vue'], resolve),
    props: true,
    meta: {
      index: 5,
      title: '酒店申请退单',
      include: [],
    }
  },
  {
    name: 'htRefundComplete',
    path: '/ht/htRefundComplete/:id',
    component: resolve => require(['Views/Ht/htRefundComplete/index.vue'], resolve),
    props: true,
    meta: {
      index: 51,
      title: '退订申请成功',
      include: [],
    }
  },
  {
    name: 'htComplete',
    path: '/ht/htComplete',
    component: resolve => require(['Views/Ht/htComplete/index.vue'], resolve),
    meta: {
      index: 6,
      title: '订单完成',
      include: [],
    }
  },
  {
    name: 'htOrderComplete',
    path: '/ht/htOrderComplete',
    component: resolve => require(['Views/Ht/htOrderComplete/index.vue'], resolve),
    meta: {
      index: 61,
      title: '订单预订完成',
      include: [],
    }
  },
    
]